module.exports = __webpack_public_path__ + "frontend/img/indicator.3476b164.svg";